var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button } from '@homeexchange/design';
import React, { useState } from 'react';
import i18n from '../../i18n';
import { trackShareButtonClick } from '../../utils/utils-ts';
import { ShareHomeModal } from '../shareHomeModal';
var canUseNativeShare = function () {
    if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
        return false;
    }
    return /Android.*Mobile|iPhone|iPod|Mobile/i.test(navigator.userAgent);
};
var getShareUrl = function (homeId, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withUtm, withUtm = _c === void 0 ? false : _c;
    var path = i18n.t('home:home.view.url', { id: homeId });
    var base = typeof window !== 'undefined' ? window.location.origin + path : path;
    return withUtm ? "".concat(base).concat(base.includes('?') ? '&' : '?', "utm_source=share") : base;
};
var HomeShareButton = function (_a) {
    var homeId = _a.homeId;
    var _b = useState(false), showShareModal = _b[0], setShowShareModal = _b[1];
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    trackShareButtonClick('home_view', homeId);
                    if (!canUseNativeShare()) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.share({ url: getShareUrl(homeId, { withUtm: true }) })];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/];
                case 4:
                    setShowShareModal(true);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { hierarchy: "secondary", onClick: handleClick, size: "large", isFullWidth: true, icon: "ShareUp" }, i18n.t('global:global.share')),
        React.createElement(ShareHomeModal, { isOpen: showShareModal, onClose: function () { return setShowShareModal(false); }, url: getShareUrl(homeId), pageLocation: "home_view", homeId: homeId })));
};
export default HomeShareButton;
